import http from "../../util/http"
export default class NoteApi {
    constructor() {
        this.post = http.post
        this.get = http.get
        this.PREFIX = "/share-foreign"
    }
    //公函管理
    getDetailOne(data) {
        let url = this.PREFIX + "/missive/missiveManage/detail"
        return http.post(url, data)
    }

    examineApproval(data) {
        let url = this.PREFIX + "/missive/missiveManage/examineApproval"
        return http.post(url, data)
    }
    //换发
    getDetailTwo(data) {
        return http.post(this.PREFIX + "/offline/renewalPassport/getDetails", data)
    }

    submitTask(data) {
        return http.post(this.PREFIX + "/offline/renewalPassport/submitTask", data)
    }
    //注销
    destoryDetail(data) {
        return http.post(this.PREFIX + "/offline/destroyPassport/details", data)
    }

    submitTaskDestroy(data) {
        return http.post(this.PREFIX + "/offline/destroyPassport/submitTask", data)
    }
    //企业备案
    detail(data) {
        let url = this.PREFIX + "/entRecord/getByCompanyId"
        return this.post(url, data)
    }

    submitTaskCompany(data) {
        let url = this.PREFIX + "/entRecord/submitTask"
        return this.post(url, data)
    }
}
